import { render, staticRenderFns } from "./Printers.vue?vue&type=template&id=5bdb3c00"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports